import MoreVertIcon from '@mui/icons-material/MoreVert';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';

import SelectLocation from '../SelectLocation';
import SelectRace from '../SelectRace';
import SelectYear from '../SelectYear';
import styles from './FilterControl.module.css';

const FilterControl = ({ selectLocation, setLocation }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.filters}>
          <div className={styles.label}>
            Filter view:
          </div>
          <div className={styles.select}>
            <SelectYear small={true} />
          </div>
          <div className={styles.select}>
            <SelectLocation small={true} />
          </div>
          <div className={styles.select}>
            <SelectRace small={true} />
          </div>
        </div>
        <div className={styles.links}>
          <div className={styles.link}>
            <a href="https://mappingpoliceviolence.org/resources" target="_blank">See our research & resources</a>
          </div>
          <div className={styles.link}>
            <a href="https://airtable.com/shroOenW19l1m3w0H" target="_blank">View the data</a>
          </div>
          <div className={styles.link}>
            <a href="https://mappingpoliceviolence.org/methodology" target="_blank">Read about the methodology</a>
          </div>
        </div>
        <div className={styles.linksMobile}>
          <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          >
            <MoreVertIcon />
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem onClick={handleClose}>
              <div className={styles.link}>
                <a href="https://mappingpoliceviolence.org/resources" target="_blank">See our research & resources</a>
              </div>
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <div className={styles.link}>
                <a href="https://airtable.com/shroOenW19l1m3w0H" target="_blank">View the data</a>
              </div>
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <div className={styles.link}>
                <a href="https://mappingpoliceviolence.org/methodology" target="_blank">Read about the methodology</a>
              </div>
            </MenuItem>
          </Menu>
        </div>
      </div>
    </div>
  );
};

export default FilterControl;
